import { render, staticRenderFns } from "./Organizational.vue?vue&type=template&id=f78b2978&scoped=true&"
import script from "./Organizational.vue?vue&type=script&lang=js&"
export * from "./Organizational.vue?vue&type=script&lang=js&"
import style0 from "./Organizational.vue?vue&type=style&index=0&id=f78b2978&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78b2978",
  null
  
)

export default component.exports